/**
 * Зависимости
 */
import {Utils} from '../../common/scripts/utils';
import YandexMap from '../../components/yandex-map';

/**
 * Карта в блоке контакты
 */
const contactsMap = document.querySelector('.j-contacts-map');
let isLoaded = false;

const initMap = () => {
    const ymaps = window.ymaps;

    ymaps.ready(() => {
        const yandexMap = new YandexMap(ymaps);

        yandexMap.init({
            wrapper                : contactsMap,
            cluster                : true,
            fullScreenControl      : true,
            customFullScreenControl: true,
            customZoomControl      : true
        });
    });
};

const initContactMap = () => {
    isLoaded = true;
    const ymaps = window.ymaps;

    if (ymaps) {
        initMap();
    } else {
        Utils.loadScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU', initMap);
    }
};

if (contactsMap) {
    if ('IntersectionObserver' in window) {
        const lazyMapObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (!isLoaded) {
                        initContactMap();
                    }
                }
            });
        }, {rootMargin: '0px 0px 1000px 0px'});

        if (Utils.isInViewport(contactsMap, window.innerHeight || document.documentElement.clientHeight)) {
            initContactMap();
        } else {
            lazyMapObserver.observe(contactsMap);
        }
    } else {
        initContactMap();
    }
}

